import { buildApiUrl } from '../config/api';
import { getAuthToken } from './session';

/** 公开展示接口（无需 token） */
const PUBLIC_API_PATHS = [
  { method: 'GET', path: '/site/info' },
  { method: 'GET', path: '/manual-upload' },
  { method: 'GET', path: '/process-flow' },
  { method: 'GET', path: '/jinghong-process-layout' },
  { method: 'POST', path: '/mqtt/values' },
  { method: 'POST', path: '/web-visit-log' },
  { method: 'POST', path: '/auth/login' },
  { method: 'GET', path: '/permission-applications/latest' },
  { method: 'GET', path: '/operation-sites' },
  { method: 'GET', path: '/hmi/board' },
  { method: 'GET', path: '/hmi/telemetry' },
  { method: 'GET', path: '/hmi/health-disk' },
  { method: 'GET', path: '/hmi/change-reports' },
  { method: 'GET', path: '/hmi/archives' },
  { method: 'GET', path: '/hmi/accounts/sync' },
  { method: 'GET', path: '/hmi/ops-hourly' },
  { method: 'GET', path: '/hmi/updates/latest' },
  { method: 'POST', path: '/hmi/change-reports' },
  { method: 'POST', path: '/hmi/accounts/sync' },
  { method: 'POST', path: '/hmi/telemetry' },
  { method: 'POST', path: '/hmi/ops-hourly' },
  { method: 'POST', path: '/hmi/identity' },
  { method: 'POST', path: '/hmi/info-unlock' },
  { method: 'POST', path: '/hmi/updates/publish' },
];

function normalizePath(endpoint) {
  const p = String(endpoint || '').split('?')[0];
  return p.startsWith('/') ? p : `/${p}`;
}

function isPublicApi(method, endpoint) {
  const m = String(method || 'GET').toUpperCase();
  const p = normalizePath(endpoint);
  return PUBLIC_API_PATHS.some((item) => {
    if (item.method !== m) return false;
    return p === item.path || p.startsWith(`${item.path}/`);
  });
}

/**
 * Web API：已登录时自动附带 Authorization
 */
export async function apiFetch(endpoint, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = { ...(options.headers || {}) };
  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  let body = options.body;
  if (body != null && typeof body !== 'string') {
    if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';
    body = JSON.stringify(body);
  }
  const res = await fetch(buildApiUrl(endpoint), { method, headers, body });
  let data = {};
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (e) {
      data = { message: text };
    }
  }
  if (res.ok) return data;
  const err = new Error((data && data.message) || `请求失败(${res.status})`);
  err.status = res.status;
  err.body = data;
  err.isPublic = isPublicApi(method, endpoint);
  throw err;
}

/** 网站账号密码登录 */
export async function passwordLogin(username, password) {
  const res = await apiFetch('/auth/login', {
    method: 'POST',
    body: { username, password },
  });
  return res.data;
}

/** 记录页面浏览（静默，失败忽略） */
export function logPageVisit(path) {
  const pagePath = String(path || '/').trim() || '/';
  apiFetch('/web-visit-log', { method: 'POST', body: { path: pagePath } }).catch(() => {});
}
